import React from "react";

const Paragraph = ({children}) => (
  <p 
    className="
      font-light
      text-gray-500
      text-base
      sm:text-xl
      py-2
    ">
    {children}
  </p>
  )

export default Paragraph;
